var exports = {
  "B_": "MessageJumpLink.module__jumpLinkButton___THZNMW",
  "y_": "MessageJumpLink.module__part___THZNMW",
  "Kk": "MessageJumpLink.module__icon___THZNMW",
  "$f": "MessageJumpLink.module__guildIcon___THZNMW",
  "yF": "MessageJumpLink.module__divider___THZNMW",
  "UU": "MessageJumpLink.module__name___THZNMW",
  "m0": "MessageJumpLink.module__noAccess___THZNMW",
};

module.exports = exports;
